import React from 'react';
import FeedInfo from './FeedInfo';

class FeedData extends React.Component {
    state = {
        navigationSelected: 'sources',
        selectedSource: this.props.selectedSource
    }
    switchType = (event) => {
        const {id} = event.target;

        if (id === "sources") {
            this.setState({
                navigationSelected: 'sources'
            })
        } else {
            this.setState({
                navigationSelected: 'teams'
            })
        }

    };

    componentDidMount() {
        // console.log('feed data selectedSource: ', this.state.selectedSource)
    }

    render() {
        const {
            source,
            user,
            onClick,
            activateFeed,
            deleteFeed,
            toggleFeedInfo,
            editing,
            user_facebook_pages,
            facebook_pages_shared,
            updateUser,
            updateSources,
            enablePlatform,
            platforms_enabled,
            rss_valid,
            openModal,
            onlypage,
            selectSource,
            teams
        } = this.props;
        //console.log("FeedData render platforms_enabled", platforms_enabled);

        return (
            <React.Fragment>

                        <FeedInfo
                            user={user}
                            source={this.props.selectedSourceNode}
                            toggleFeedInfo={toggleFeedInfo}
                            editing={editing}
                            rss_valid={rss_valid}
                            openModal={openModal}
                            teams={teams}
                            activateFeed={activateFeed}
                            deleteFeed={deleteFeed}
                            selectedSource={this.props.selectedSource}
                            selectedSourceNode={this.props.selectedSourceNode}
                            appPropagateTeams={this.props.appPropagateTeams}
                            updateUserFromServer={this.props.updateUserFromServer}
                            selectSource={selectSource}
                            {...this.props}
                        />

            </React.Fragment>
        )
    }
}

export default FeedData